import {
    RolesTypes,
} from 'app/utils/hasPermission'

const PROSPECT_READ_ONLY_LIST: RolesTypes[] = [
    'location_airlines',
    'location_bil',
    'location_ops',
    'location_prd',
    'location_rnd',
    'location_cs_super',
    'location_ops_super',
    'location_pmo_super',
    'location_read',
]

export default PROSPECT_READ_ONLY_LIST
